module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zan-card"
  }, [_c('img', {
    staticClass: "zan-card__img",
    attrs: {
      "src": _vm.thumb,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zan-card__content",
    class: {
      'is-center': !this.$slots.footer
    }
  }, [_c('div', {
    staticClass: "zan-card__info"
  }, [_vm._t("title", [_c('h4', {
    staticClass: "zan-card__title",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), _vm._t("desc", [(_vm.desc) ? _c('p', {
    staticClass: "zan-card__title",
    domProps: {
      "textContent": _vm._s(_vm.desc)
    }
  }) : _vm._e()]), _vm._v(" "), _vm._t("tags")], 2), _vm._v(" "), _vm._t("footer")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-34ef9da1!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/card/src/card.vue
// module id = 144
// module chunks = 0 2